import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Sidebar from './components/Sidebar';
import NavbarNav from './components/NavbarNav';
import Admin from './components/Admin';
import AdminAuth from './components/AdminAuth';
import CatalogoProveedores from './components/CatalogoProveedores';
import AdminProveedores from './components/AdminProveedores';
import NewMenores from './pages/NewMenores';
import MenoresVigentes from './pages/MenoresVigentes';
import Menores from './pages/Menores';
import NewMenorescopy from './pages/NewMenores copy.js';
import Menorescopy from './pages/Menores copy.js';
import CourseCatalog from './pages/CourseCatalog';
import CourseAdmin from './pages/CourseAdmin';
// ✅ IMPORTACIONES PARA TUTORIALES Y CALENDARIO
import Calendario from './components/Calendario';
import PromoTimer from './components/PromoTimer';
import PromoHalloween from './components/PromoHalloween';
import RecursosUtiles from './pages/RecursosUtiles';
import SEACENuevos from './pages/SEACENuevos.js';
import CoursePlatform from './components/CoursePlatform'; // Player de videos
import AcademiaCursos from './components/AcademiaCursos'; // ✅ NUEVO COMPONENTE
import RutaConPlan from './components/RutaConPlan'; // Secciones según el plan del usuario
import { SECCION_MENORES_VIGENTES, SECCION_TRABAJA_ESTADO } from './components/planPermissions';
import ProtectedCourseRoute from './components/ProtectedCourseRoute'; // ✅ PROTECCIÓN DE RUTAS
import PrediccionLicitaciones from './pages/prediccion.js';
import SEACE_PRUEBA from './pages/SEACENuevos copy.js';
import AprendeLicitar from './components/AprendeLicitar.js';
import { verificarUsuario } from './services/userService';
import {
  SitiosOficiales,
  MarcoLegal,
  HerramientasCalculo,
  FormatosPlantillas,
  Capacitacion
} from './pages/RecursosSubcategories';
// ✅ Por esto:
import Tutoriales from './pages/Tutoriales';
import {
  TutorialProcesosMenores8UIT,
  TutorialBusquedaAvanzadaSEACE,
  TutorialPorSlug,
  TutorialIntroduccionLicitaHub
} from './pages/TutorialPages';

import 'bootstrap/dist/css/bootstrap.min.css';
import { MenoresProvider } from './contexts/MenoresContext';
import PACProgramado from './pages/PACProgramado';
import PACgeneral from './pages/PACGeneral';
import { DashboardProvider } from './contexts/DashboardContext';
import { PacProvider } from './contexts/PacContext';
import SEACE from './pages/SEACE';
import EstadisticasPage from './pages/EstadisticasPage';
import AnalisisCompetidorPage from './pages/AnalisisCompetidorPage';
import SeguimientoPagosPage from './pages/SeguimientoPagosPage';
import TrabajaEstadoPage from './pages/TrabajaEstadoPage';
import Talleres from './pages/Talleres';
import GeneradorOfertaPage from './pages/GeneradorOfertaPage';

const getUserStorage = () => sessionStorage.getItem('nuvia_user') ? sessionStorage : localStorage;

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  // Queda en true en cuanto la promoción de Halloween se muestra: así no se
  // apilan dos ventanas emergentes en la misma carga (el aviso del plan de
  // prueba vuelve a salir en la siguiente).
  const [promoHalloweenVista, setPromoHalloweenVista] = useState(false);
  // Cada pulsación del botón de la barra superior reabre el flyer.
  const [promoHalloweenAperturas, setPromoHalloweenAperturas] = useState(0);
  const [bienvenidaAbierta, setBienvenidaAbierta] = useState(false);
  const [abrirPreferencias, setAbrirPreferencias] = useState(0);
  const [esComputadora, setEsComputadora] = useState(() => window.matchMedia('(min-width: 768px)').matches);

  useEffect(() => {
    const media = window.matchMedia('(min-width: 768px)');
    const actualizarVista = () => setEsComputadora(media.matches);
    media.addEventListener('change', actualizarVista);
    return () => media.removeEventListener('change', actualizarVista);
  }, []);

  useEffect(() => {
    if (!user?.email || !esComputadora) {
      setBienvenidaAbierta(false);
      return;
    }
    const key = `nuvia:onboarding-preferencias:${user.email.toLowerCase()}`;
    if (!localStorage.getItem(key)) setBienvenidaAbierta(true);
  }, [user?.email, esComputadora]);

  const cerrarBienvenida = () => {
    if (user?.email) localStorage.setItem(`nuvia:onboarding-preferencias:${user.email.toLowerCase()}`, 'visto');
    setBienvenidaAbierta(false);
  };

  const iniciarRecorrido = () => {
    cerrarBienvenida();
    setAbrirPreferencias(n => n + 1);
  };

  useEffect(() => {
    const checkStoredUser = async () => {
      try {
        const storedUser = getUserStorage().getItem('nuvia_user');
        if (storedUser) {
          const userData = JSON.parse(storedUser);
          if (userData.email && userData.name && userData.plan) {
            // Re-verificar suscripción contra Supabase
            const verificacion = await verificarUsuario(userData.email);
            if (verificacion.autorizado) {
              // Actualizar datos frescos (días restantes, estado)
              const datosActualizados = {
                ...userData,
                curso_tipo: verificacion.usuario.curso_tipo,
                dias_restantes: verificacion.usuario.dias_restantes,
                estado: verificacion.usuario.estado
              };
              getUserStorage().setItem('nuvia_user', JSON.stringify(datosActualizados));
              setUser(datosActualizados);
            } else {
              // Suscripción vencida o usuario eliminado — cerrar sesión
              console.warn('⚠️ Sesión inválida o suscripción vencida:', verificacion.mensaje);
              localStorage.removeItem('nuvia_user');

              sessionStorage.removeItem('nuvia_user');
            }
          } else {
            localStorage.removeItem('nuvia_user');

            sessionStorage.removeItem('nuvia_user');
          }
        }
      } catch (error) {
        console.error('❌ Error al verificar sesión:', error);
        // En caso de error de red, permitir continuar con localStorage
        try {
          const storedUser = getUserStorage().getItem('nuvia_user');
          if (storedUser) {
            const userData = JSON.parse(storedUser);
            if (userData.email && userData.name && userData.plan) {
              setUser(userData);
            }
          }
        } catch {}
      } finally {
        setLoading(false);
      }
    };

    checkStoredUser();
  }, []);

  const handleLoginSuccess = (userData) => {
    console.log('✅ Login exitoso en App:', userData);
    setUser(userData);
    
    // Verificar que localStorage se haya guardado correctamente
    try {
      const saved = getUserStorage().getItem('nuvia_user');
      if (!saved) {
        console.log('💾 Guardando usuario en localStorage desde App.js');
        getUserStorage().setItem('nuvia_user', JSON.stringify(userData));
      }
    } catch (error) {
      console.error('❌ Error guardando usuario en localStorage:', error);
    }
  };

  const handleLogout = async () => {
    try {
      // Limpiar localStorage
      localStorage.removeItem('nuvia_user');

      sessionStorage.removeItem('nuvia_user');
      setUser(null);
      console.log('✅ Logout exitoso - localStorage limpiado');
    } catch (error) {
      console.error('❌ Error en logout:', error);
    }
  };

  const toggleSidebar = (collapsed) => {
    setSidebarCollapsed(collapsed);
  };

  // Pantalla de loading durante la verificación inicial
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ 
        height: '100vh',
        background: '#0f4f47'
      }}>
        <div className="text-center text-white">
          <div className="spinner-border text-light mb-3" style={{ width: '3rem', height: '3rem' }} role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
          <h5 className="mb-2">Verificando sesión...</h5>
          <p className="mb-0 opacity-75">Un momento por favor</p>
        </div>
      </div>
    );
  };

  // Esconder el enlace en el Sidebar no basta: sin esto se entra a cualquier
  // sección escribiendo la URL a mano. El nombre de la sección es el mismo que
  // usa PLAN_PERMISSIONS, para que menú y ruta digan siempre lo mismo.
  const conPlan = (seccion, elemento) => (
    <RutaConPlan user={user} seccion={seccion}>{elemento}</RutaConPlan>
  );

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <Router>
        <div className="app-container">
         {user ? (
  <DashboardProvider>
    <PacProvider>
      <MenoresProvider>
      {/* Sidebar */}
      <Sidebar 
        user={user} 
        isCollapsed={sidebarCollapsed}
        onToggle={toggleSidebar}
        onLogout={handleLogout}
      />
      
      {/* Main Content */}
      <div className={`main-content ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        {/* Navbar */}
      <NavbarNav
          user={user}
          onLogout={handleLogout}
          onAbrirPromo={() => setPromoHalloweenAperturas((n) => n + 1)}
          abrirPreferencias={abrirPreferencias}
          onIniciarRecorrido={() => setAbrirPreferencias(n => n + 1)}
        />
        {bienvenidaAbierta && <div role="presentation" style={{ position: 'fixed', inset: 0, zIndex: 13000, background: 'rgba(15,23,42,.58)', display: 'grid', placeItems: 'center', padding: 20 }}>
          <section role="dialog" aria-modal="true" aria-labelledby="bienvenida-titulo" style={{ width: 'min(100%, 480px)', background: '#fff', borderRadius: 20, padding: 30, boxShadow: '0 24px 80px rgba(15,23,42,.28)' }}>
            <div style={{ color: '#0f766e', fontWeight: 700, fontSize: 13, letterSpacing: '.08em', marginBottom: 10 }}>BIENVENIDO A LICITAHUB</div>
            <h2 id="bienvenida-titulo" style={{ color: '#14231f', fontSize: 25, fontWeight: 750, marginBottom: 10 }}>¿Quieres personalizar tus correos?</h2>
            <p style={{ color: '#52615d', lineHeight: 1.6, marginBottom: 24 }}>Te guiamos para elegir qué alertas recibir, tus tipos de contratación y las regiones que te interesan. Puedes cambiarlo después desde Preferencias.</p>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, flexWrap: 'wrap' }}>
              <button type="button" onClick={cerrarBienvenida} style={{ border: '1px solid #d8e1de', background: '#fff', color: '#42524d', borderRadius: 10, padding: '11px 16px', fontWeight: 600 }}>Ahora no</button>
              <button type="button" onClick={iniciarRecorrido} style={{ border: 0, background: '#0f766e', color: '#fff', borderRadius: 10, padding: '11px 18px', fontWeight: 650 }}>Sí, personalizar</button>
            </div>
          </section>
        </div>}
        <PromoHalloween
          user={user}
          onMostrar={() => setPromoHalloweenVista(true)}
          aperturaSolicitada={promoHalloweenAperturas}
        />
        {!promoHalloweenVista && <PromoTimer user={user} />}
       {/* Content Wrapper */}
<div className="content-wrapper">
  <Routes>
    {/* Ruta principal - Dashboard */}
    <Route 
      path="/" 
      element={
        <Dashboard 
          user={user}
          onToggleSidebar={toggleSidebar} // ✅ IMPORTANTE
        />
      } 
    />
    <Route path="/dashboard" element={<Navigate to="/" replace />} />
            
            {/* Rutas para Contratos Menores */}
            <Route 
              path="/Contratos menores" 
              element={conPlan('Contratos Menores', <Menores user={user} />)} 
            />
            <Route 
              path="/Contratos menores/nuevas" 
              element={conPlan('Contratos Menores', <NewMenores user={user} />)} 
            />
            <Route 
              path="/Contratos menores/vigentes" 
              element={conPlan(SECCION_MENORES_VIGENTES, <MenoresVigentes user={user} />)} 
            />
             <Route 
  path="/Contratos menores (Old)" 
  element={<Menorescopy user={user} />} 
/>
<Route 
  path="/Contratos menores (Old)/nuevas" 
  element={<NewMenorescopy user={user} />} 
/> 
            

            {/* Rutas para Contratos Mayores */}
            <Route 
              path="/SEACE" 
              element={conPlan('SEACE', <SEACE user={user} title="Contratos Mayores" />)} 
            />
            <Route
              path="/SEACE/nuevos"
              element={conPlan('SEACE', <SEACENuevos user={user} />)}
            />
            <Route
              path="/SEACE/generador-oferta"
              element={<GeneradorOfertaPage user={user} />}
            />
            {/* Rutas para PAC */}
            <Route 
              path="/PAC" 
              element={conPlan('PAC', <PACgeneral user={user} title="PAC - Vista Consolidada" />)} 
            />
            <Route 
              path="/PAC/nuevas" 
              element={conPlan('PAC', <PACProgramado title="PAC - Convocatorias del Día" />)} 
            />
            
            {/* ✅ NUEVA RUTA PARA CALENDARIO */}
            <Route 
              path="/Calendario" 
              element={conPlan('Calendario', <Calendario user={user} />)} 
            />
            <Route 
                          path="/aprende-licitar" 
                          element={<AprendeLicitar user={user} />} 
                        />
            {/* ✅ RUTAS PARA TUTORIALES */}
            <Route 
              path="/tutoriales" 
              element={conPlan('Tutoriales', <Tutoriales user={user} />)} 
            />
            <Route 
              path="/tutoriales/introduccion-licitahub" 
              element={<TutorialIntroduccionLicitaHub />} 
            />
            <Route 
              path="/tutoriales/procesos-menores-8-uit" 
              element={<TutorialProcesosMenores8UIT />} 
            />
            <Route
              path="/tutoriales/busqueda-avanzada-seace"
              element={<TutorialBusquedaAvanzadaSEACE />}
            />
            {/* Cualquier otro tutorial del catálogo se resuelve por su slug */}
            <Route
              path="/tutoriales/:slug"
              element={<TutorialPorSlug />}
            />
     
            
            {/* ✅ RUTAS PARA CURSOS */}
            <Route path="/cursos/admin" element={<AdminAuth><CourseAdmin user={user} /></AdminAuth>} />
            <Route path="/cursos" element={<CourseCatalog user={user} />} />
            
            {/* ✅ CAMBIO 1: Academia de Cursos (Lista y Detalle) */}
            <Route 
              path="/cursos/academia" 
              element={<AcademiaCursos user={user} />} 
            />
            
            {/* ✅ CAMBIO 2: Player de Videos del Curso - PROTEGIDO */}
            <Route 
              path="/cursos/player/:courseId" 
              element={
                <ProtectedCourseRoute user={user}>
                  <CoursePlatform user={user} />
                </ProtectedCourseRoute>
              } 
            />
            
            {/* Rutas para Proveedores y Admin */}
            <Route 
              path="/proveedores" 
              element={conPlan('Catálogo de Proveedores', <CatalogoProveedores user={user} />)} 
            />
            <Route 
              path="/prediccion-ia" 
              element={conPlan('Predicción con IA', <PrediccionLicitaciones user={user} />)} 
            />
            
            {/* Estadísticas */}
            <Route
              path="/estadisticas"
              element={conPlan('Estadísticas', <EstadisticasPage user={user} />)}
            />

            {/* Análisis de Competidor - historial de contrataciones del
                proveedor (OECE). Abierta a todos los planes: el permiso vive en
                SECCIONES_LIBRES, no en PLAN_PERMISSIONS. */}
            <Route
              path="/analisis-competidor"
              element={conPlan('Análisis de Competidor', <AnalisisCompetidorPage user={user} />)}
            />
            {/* La sección se llamaba "Empresas": los enlaces viejos siguen entrando. */}
            <Route path="/empresas" element={<Navigate to="/analisis-competidor" replace />} />

            {/* Seguimiento de Pagos - expediente SIAF en el portal del MEF.
                Pasa por la Edge Function `mef-expediente` (captcha + CORS). */}
            <Route
              path="/seguimiento-pagos"
              element={conPlan('Seguimiento de Pagos', <SeguimientoPagosPage user={user} />)}
            />

            {/* Trabaja para el Estado - convocatorias de empleo público (CAS).
                Lee `trabajos_estado` directo de Supabase. La ven todos los
                planes menos el Básico: el permiso se arma sobre
                PLAN_PERMISSIONS (ver PLANES_SIN_TRABAJA_ESTADO). */}
            <Route
              path="/trabaja-estado"
              element={conPlan(SECCION_TRABAJA_ESTADO, <TrabajaEstadoPage user={user} />)}
            />

            {/* Talleres */}
            <Route
              path="/talleres"
              element={<Talleres user={user} />}
            />

            {/* Ruta de Administración - Componente Admin real */}
            <Route
              path="/admin"
              element={<AdminAuth><Admin /></AdminAuth>}
            />

            {/* Ruta de Administración de Proveedores - Solo ADMI */}
            <Route 
              path="/admin/proveedores" 
              element={<AdminAuth><AdminProveedores user={user} /></AdminAuth>} 
            />
            
            {/* ✅ RUTAS PARA RECURSOS ÚTILES */}
            <Route 
              path="/recursos" 
              element={<RecursosUtiles user={user} />} 
            />
            <Route 
              path="/recursos/sitios-oficiales" 
              element={<SitiosOficiales />} 
            />
            <Route 
              path="/recursos/marco-legal" 
              element={<MarcoLegal />} 
            />
            <Route 
              path="/recursos/herramientas" 
              element={<HerramientasCalculo />} 
            />
            <Route 
              path="/recursos/formatos" 
              element={<FormatosPlantillas />} 
            />
            <Route 
              path="/recursos/capacitacion" 
              element={<Capacitacion />} 
            />
            {/* Ruta por defecto */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </div>
      </MenoresProvider>
    </PacProvider>
  </DashboardProvider>
) : (
  /* Pantalla de Login - Aquí se valida contra Supabase */
  <Login onLoginSuccess={handleLoginSuccess} />
)}
        </div>
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;
